/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Workout_Swap_Scope_Never_NoteInputs */

const en_us2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Swaps it in the plan and drops ${i?.from} from suggestions`)
};

const pt_br2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Troca no plano e ${i?.from} sai das sugestões`)
};

const es_419_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lo cambia en el plan y ${i?.from} sale de las sugerencias`)
};

const pt_pt2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Troca no plano e ${i?.from} sai das sugestões`)
};

const fr_fr2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change dans le programme et retire ${i?.from} des suggestions`)
};

const de_de2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tauscht im Plan und nimmt ${i?.from} aus den Vorschlägen`)
};

const it_it2_workout_swap_scope_never_note = /** @type {(inputs: Workout_Swap_Scope_Never_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lo cambia nella scheda e ${i?.from} esce dai suggerimenti`)
};

/**
* | output |
* | --- |
* | "Swaps it in the plan and drops {from} from suggestions" |
*
* @param {Workout_Swap_Scope_Never_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_never_note = /** @type {((inputs: Workout_Swap_Scope_Never_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_Never_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_never_note(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_never_note(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_never_note(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_never_note(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_never_note(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_never_note(inputs)
	return en_us2_workout_swap_scope_never_note(inputs)
});
export { workout_swap_scope_never_note as "workout-swap.scope_never_note" }